import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './components/auth/Login';
import DashboardComponent from './components/DashboardComponent';
import Page from './components/Page';

import { ConfigProvider } from 'antd';
import ptBR from 'antd/es/locale/pt_BR';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';

// Define o locale do dayjs para pt-br (importante para componentes de data)
dayjs.locale('pt-br');

const RouterComponent = () => {
  return (
    <ConfigProvider locale={ptBR}>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/dashboard" element={<DashboardComponent />} />
           {/* Rota dinâmica para a página dos cards */}
          <Route path="/pagina/:title" element={<Page />} />
        </Routes>
      </Router>
    </ConfigProvider>
  );
};

export default RouterComponent;
